import pkgInfo from "../../package.json";

// Breakpoints
export const BREAKPOINT_DOWN_SMALL = "(max-width: 767px)";
export const BREAKPOINT_UP_MEDIUM = "(min-width: 1025px)";
export const BREAKPOINT_DOWN_MEDIUM = "(max-width: 1024px)";

export const EVENTS_API = "https://eventsdata.axios.com/upcoming-events.json";

// Draft js
export const BLOCK_TYPE = {
  // defaults from draft.js
  UNSTYLED: "unstyled",
  SUBHEAD: "header-two",
  UNORDERED_LIST_ITEM: "unordered-list-item",
  ORDERED_LIST_ITEM: "ordered-list-item",

  // custom block types
  EMBED: "embed",
  STYLED_QUOTE: "styled-quote",
  PLAIN_QUOTE: "plain-quote",
  QUOTE_ATTRIBUTION: "quote-attribution",
  IMAGE: "image",
  KEEP_READING: "keep-reading",
  AXIOM: "axiom",

  // used locally
  CAPTION: "caption",
};

export const EMBED_TYPE = {
  ART19: "art19",
  AXIOS_VISUAL: "axios-visual",
  DOCUMENTCLOUD: "documentcloud-document",
  FACEBOOK_POST: "facebook-post",
  FACEBOOK_VIDEO: "facebook-video",
  GIPHY: "giphy",
  INSTAGRAM: "instagram",
  JWPLAYER_VIDEO: "jwplayer-video",
  TWITTER: "twitter",
  VIMEO: "vimeo",
  YOUTUBE: "youtube",
};

export const STYLE_TYPE = {
  BOLD: "bold",
  ITALIC: "italic",
};

export const ENTITY_TYPE = {
  LINK: "link",
};

export const STREAM_TYPE = {
  SECTION: "section",
  TAG: "tag",
  PERMALINK: "permalink",
  SEARCH: "search",
  AUTHOR: "author",
};

export const INCLUSION_EDGE_TYPE = {
  CONTENT: "ContentInclusionEdge",
  AD: "AdInclusionEdge",
  NEWSLETTER_PROMO: "NewsletterPromoInclusionEdge",
};

export const IMAGE_ASPECT_RATIO = {
  SQUARE: 1,
  LEAD: 16 / 9,
};

export const SIZES =
  "(min-width: 1025px) calc(100vw - 470px), (min-width: 769px) calc(100vw - 80px), 100vw";

export const TRACK_LAST_SEEN = [STREAM_TYPE.SECTION];

export const STREAM_TRACKING = {
  VIEWPORT_RATIO: 0.4, // minimum percentage of viewport taken up by a stream item to be a candidate for page view
  ELEMENT_RATIO: 1, // percentage of a stream item in viewport to be a candidate for page view
  TIMEOUT_LENGTH: 3000, // how long a stream item needs to be in the viewport before a page view is counted
};

export const SECTION = {
  TOP: { slug: "top" },
  SMARTER_FASTER: { slug: "smarter-faster" },
};

export const TAG = {
  MIDTERM_ELECTIONS_2018: { slug: "2018-midterm-elections" },
  REFUGEE_CRISIS: { slug: "deep-dive-refugee-crisis" },
  FUTURE_OF_RETAIL: { slug: "deep-dive-future-of-retail" },
  DAVOS: { slug: "deep-dive-davos" },
  BUSINESS_OF_SPORTS: { slug: "deep-dive-business-of-sports" },
  FUTURE_OF_DATING: { slug: "deep-dive-future-of-dating" },
  DATA_PRIVACY: { slug: "deep-dive-data-privacy" },
};

// Enumerates these integers https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-networkStatus
export const APOLLO_NETWORK_STATUS = {
  LOADING: 1,
  SET_VARIABLES: 2,
  FETCH_MORE: 3,
  REFETCH: 4,
  POLL: 6,
  READY: 7,
  ERROR: 8,
};

// Used by FetchOnSubmit
export const FETCH_STATUS = {
  READY: 1,
  LOADING: 2,
  SUCCESS: 7,
  ERROR: 8,
};

export const DEFAULT_CARD_HEIGHT = {
  FULL_STORY_CARD: 500,
  SUMMARY_CARD: 200,
};

export const DROPDOWN_DISPLAY_VALUE = {
  SHOW: "SHOW",
  SHOWN: "SHOWN",
  HIDE: "HIDE",
  HIDDEN: "HIDDEN",
};

export const URL_ID_REGEXP =
  "([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9]+)";

// "Musical Meerkat" key - the default key's secret component was exposed to GitHub
export const RAVEN_DSN =
  "https://1b87f5b715e44d8496741fe423b7c3de@sentry.io/247977";

export const FACTS_MATTER_TEMPLATE = "00000000-0000-0000-0003-000000000001";

export const FB_JS_SDK_VERSION = "2.12";

export const SOCIAL_LINKS = [
  {
    name: "facebook",
    url: "https://www.facebook.com/axiosnews/",
    description: "Axios Facebook",
    gtmClass: "gtm-nav-facebook",
  },
  {
    name: "twitter",
    url: "https://www.twitter.com/axios",
    description: "Axios Twitter",
    gtmClass: "gtm-nav-twitter",
  },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/company/next-great-media-company/",
    description: "Axios LinkedIn",
    gtmClass: "gtm-nav-linkedin",
  },
  {
    name: "instagram",
    url: "https://www.instagram.com/axios",
    description: "Axios Instagram",
    gtmClass: "gtm-nav-instagram",
  },
];

export const SHARE_LINKS = [
  {
    NAME: "facebook",
    DESCRIPTION: "Share on Facebook",
    URL: "https://www.facebook.com/sharer/sharer.php",
    URL_PARAM: "u",
    ANALYTICS_PARAMS: {
      utm_source: "facebook",
      utm_medium: "fbsocialshare",
      utm_campaign: "organic",
    },
  },
  {
    NAME: "twitter",
    DESCRIPTION: "Share on Twitter",
    URL: "https://twitter.com/share",
    URL_PARAM: "url",
    ANALYTICS_PARAMS: {
      utm_source: "twitter",
      utm_medium: "twsocialshare",
      utm_campaign: "organic",
    },
    SOCIAL_PARAMS: { text: "" },
  },
  {
    NAME: "linkedin",
    DESCRIPTION: "Share on LinkedIn",
    URL: "https://www.linkedin.com/sharing/share-offsite",
    URL_PARAM: "url",
    ANALYTICS_PARAMS: {
      utm_source: "linkedin",
      utm_medium: "lisocialshare",
      utm_campaign: "organic",
    },
    SOCIAL_PARAMS: { mini: false },
  },
];

export const COPY_LINK = {
  NAME: "link",
  DESCRIPTION: "Copy permalink to your clipboard",
};

export const SSR_USER_AGENT = `First Order/${pkgInfo.version}`;

export const GTM_EVENTS = {
  IN_VIEW: "GA_Site_In_View_Event",
  CARD_IN_VIEW: "GA_Card_In_View_Event",
  MODULE_IN_VIEW: "GA_Module_In_View_Event",
  PAGE_VIEW: "GA_Virtual_Pageviews_Event",
  THREE_SEC_IN_VIEW: "GA_Card_3_Sec_View_Event",
};

export const HEADER_LEVELS = {
  STREAM_DEFAULT: {
    streamHeader: 1, // applies to author, tag and section (not top stories)
    latestStoriesHeader: 2,
    miniStoryCardHeader: 3,
    contentSubheading: 4,
    mainContentSubheading: 4,
  },
  TOP_STORIES_STREAM: {
    streamHeader: 2,
    latestStoriesHeader: 2,
    miniStoryCardHeader: 3,
    contentSubheading: 4,
    mainContentSubheading: 4,
  },
  PERMALINK_STREAM: {
    streamHeader: 0,
    latestStoriesHeader: 3,
    miniStoryCardHeader: 4,
    contentSubheading: 4,
    mainContentSubheading: 2,
  },
};

export const EV_RUBRIC = {
  name: "EXPERT VOICES",
  hex_color: "fc4f3b",
};

// Variables exported below are provided to the bundle via Webpack HTML inlining,
// sourced from environment variables. App code imports them from here for easy mockability.
export * from "../../common/requiredConfig/window";
